import React, { useCallback, useEffect, useState } from 'react';
import Heading from 'components/Heading/Heading';
import { H5, P } from 'components/reusable-css';
import * as Styles from 'pages/member/firewall/FireWall.style';
import { Icon } from 'semantic-ui-react';
import './Dropdown.css';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CreateTemplatePanel from './firewall/CreateTemplatePanel';
import SlidingPanels from 'components/common/sliding-panel';
import { useMediaQuery } from '@mui/material';
import { handleConvert } from './utils';

const GlobalFirewall = ({ vsFirewall, refetch }) => {
  const [show, setShow] = useState(false);
  const [rowID, setRowId] = useState();
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const handleSettingPanel = () => setIsOpenSetting(false);
  const { t } = useTranslation();
  const match = useMediaQuery('(max-width:550px)');
  const [isOpenCreateObj, setIsOpenCreateObj] = useState(false);

  const escFunction = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        if (isOpenCreateObj) {
          setIsOpenCreateObj(false);
          return;
        }
        setIsOpenSetting(false);
      }
    },
    [isOpenSetting, isOpenCreateObj],
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  return (
    <Styles.Step1SC>
      <Heading name={'vs/firewall.string1'}>
        <Styles.FireWallSC>
          <P>{t('vs/firewall.string2')}</P>
          <Styles.ListContainer>
            {vsFirewall?.firewall_ruleset?.map(
              (item) =>
                item.type == 'global' && (
                  <Styles.SingleList key={item.id}>
                    <Styles.CardContent>
                      <Styles.FirstContent>
                        <Icon name="circle" />
                        <H5>{handleConvert(item.label)}</H5>
                      </Styles.FirstContent>
                      <Styles.SecondContent>
                        <Styles.StatusConteiner>
                          <Styles.BlueContainer>
                            <P>
                              {t(item?.vs_total > 1 ? 'vs/firewall.string4' : 'vs/firewall.string3', {
                                vs_total: item?.vs_total,
                              })}
                            </P>
                          </Styles.BlueContainer>
                          <Styles.GreenContainer>
                            <P>
                              {t('vs/firewall.string5', {
                                rules: item?.rules_total,
                              })}
                            </P>
                          </Styles.GreenContainer>
                        </Styles.StatusConteiner>
                        <Styles.ActionConteiner>
                          <Icon size="large" name="setting" onClick={() => setIsOpenSetting(true)} />

                          <Dropdown
                            onToggle={() => {
                              setShow(!show);
                              setRowId(item?.id);
                            }}
                            show={show && item.id == rowID}
                          >
                            <Dropdown.Toggle id="dropdown-basic">
                              <MoreHorizIcon />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              style={{ borderRadius: '10px', boxShadow: 'unset', zIndex: 99999 }}
                              className="menu"
                            >
                              <Dropdown.Item
                                style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                                className="icon d-flex"
                              >
                                <Icon className="play circle outline" />
                                <P>{t('vs/firewall.string59')}</P>
                              </Dropdown.Item>
                              <Dropdown.Item
                                style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                                className="icon d-flex"
                              >
                                <Icon className="pause circle outline" />
                                <P>{t('vs/firewall.string60')}</P>
                              </Dropdown.Item>
                              <Dropdown.Item
                                style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                                className="icon d-flex"
                              >
                                <Icon className="cogs" />
                                <P>{t('vs/firewall.string61')}</P>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Styles.ActionConteiner>
                      </Styles.SecondContent>
                    </Styles.CardContent>
                    {isOpenSetting && (
                      <SlidingPanels size={match ? 100 : 78} isOpen={isOpenSetting} isClose={setIsOpenSetting}>
                        <CreateTemplatePanel
                          item_id={item?.id}
                          label={handleConvert(item?.label)}
                          isClose={handleSettingPanel}
                          mainRefectch={refetch}
                          isOpenCreateObj={isOpenCreateObj}
                          setIsOpenCreateObj={setIsOpenCreateObj}
                        />
                      </SlidingPanels>
                    )}
                  </Styles.SingleList>
                ),
            )}
          </Styles.ListContainer>
        </Styles.FireWallSC>
      </Heading>
    </Styles.Step1SC>
  );
};

export default GlobalFirewall;
